import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer } from 'recharts';
import SkeletonWrapper from '@shared/components/skeleton/SkeletonWrapper';
import constants from '@shared-styles/constants.module.scss';
import BarChartTooltip from './BarChartTooltip';

const CHART_DATA_KEYS = {
  NAME: 'name',
  VALUE: 'value',
  YAXIS_UNIT: '%'
};

/**
 * @typedef {object} DemographicsBarChartData
 * @property {string} name
 * @property {number} value
 */

/**
 * @typedef {object} DemographicsBarChartProps
 * @property {DemographicsBarChartData[]} [data]
 * @property {boolean} [loading]
 */

/**
 * @param {DemographicsBarChartProps} props
 */
const DemographicsBarChart = props => {
  const { data = [], loading = false } = props;

  return (
    <SkeletonWrapper show={loading} skeletonClassName='chart-skeleton-wrapper' inheritParentSize>
      <ResponsiveContainer width='90%' minWidth='40%' height={400}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray='3 3' />
          <XAxis dataKey={CHART_DATA_KEYS.NAME} />
          <YAxis unit={CHART_DATA_KEYS.YAXIS_UNIT} domain={[0, 100]} />
          <Tooltip content={<BarChartTooltip />} />
          <Bar dataKey={CHART_DATA_KEYS.VALUE} fill={constants.organizationColor} />
        </BarChart>
      </ResponsiveContainer>
    </SkeletonWrapper>
  );
};

export default DemographicsBarChart;
